import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  :root {
    --color-bg: #f8f8fb;
    --color-bg-elevated: #ffffff;
    --color-bg-card: #ffffff;
    --color-bg-card-hover: #f0f0f5;
    --color-border: #e2e2ea;
    --color-text: #1a1a2e;
    --color-text-secondary: #5a5a72;
    --color-text-muted: #8888a0;
    --color-accent: #6c5ce7;
    --color-accent-hover: #5a4bd6;
    --color-accent-glow: rgba(108, 92, 231, 0.1);
    --color-success: #00b88c;
    --color-checkmark: #6c5ce7;
    --color-gradient-start: #6c5ce7;
    --color-gradient-end: #00b88c;
    --color-nav-bg: rgba(248, 248, 251, 0.85);
    --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
    --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --max-width: 1200px;
    --header-height: 72px;
  }

  [data-theme="dark"] {
    --color-bg: #0a0a0f;
    --color-bg-elevated: #12121a;
    --color-bg-card: #1a1a25;
    --color-bg-card-hover: #22222f;
    --color-border: #2a2a3a;
    --color-text: #e8e8f0;
    --color-text-secondary: #9898a8;
    --color-text-muted: #68687a;
    --color-accent: #6c5ce7;
    --color-accent-hover: #7d6ff0;
    --color-accent-glow: rgba(108, 92, 231, 0.15);
    --color-success: #00d2a0;
    --color-checkmark: #00d2a0;
    --color-gradient-start: #6c5ce7;
    --color-gradient-end: #00d2a0;
    --color-nav-bg: rgba(10, 10, 15, 0.85);
    --shadow-card: none;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: var(--font-family);
    background-color: var(--color-bg);
    color: var(--color-text);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  a {
    color: var(--color-accent);
    text-decoration: none;
    transition: color 0.2s ease;
  }

  a:hover {
    color: var(--color-accent-hover);
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button {
    font-family: var(--font-family);
    cursor: pointer;
    border: none;
    outline: none;
  }

  ::selection {
    background: var(--color-accent);
    color: white;
  }
`

export default GlobalStyles
